<template>
  <div class="sl-label">
    <slot name="title">
      <div class="sl-label-title" :style="labelStyles">{{title}}</div>
    </slot>
    <div class="sl-label-content">
      <slot><span>{{content}}</span></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Label',
  props: {
    title: {
      type: String,
      default: ''
    },

    content: {
      default: ''
    },

    labelWidth: {
      type: Number
    }
  },
  computed: {
    labelStyles() {
      let style = {}
      const labelWidth = this.labelWidth === 0 || this.labelWidth ? this.labelWidth  : 80
      if (labelWidth || labelWidth === 0) {
        style.width = `${labelWidth}px`
      }
      return style
    }
  }
}

</script>
<style lang='scss'>
.sl-label {
  margin: 5px 0;
  display: flex;

  .sl-label-title {
    flex: 0 0 auto;
    text-align: right;
    vertical-align: middle;
    // float: left;
    font-size: 12px;
    color: #515a6e;
    line-height: 1;
    padding: 10px 12px 10px 0;
    box-sizing: border-box;
    color: rgba(30, 30, 30, .7);
  }

  .sl-label-content {
    position: relative;
    line-height: 32px;
    font-size: 12px;
    color: #000;
    flex: 1 1 auto;

  }
}

</style>
